import { render, staticRenderFns } from "./tenant-edit.vue?vue&type=template&id=6afa7364&scoped=true"
import script from "./tenant-edit.vue?vue&type=script&lang=ts"
export * from "./tenant-edit.vue?vue&type=script&lang=ts"
import style0 from "./tenant-edit.vue?vue&type=style&index=0&id=6afa7364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa7364",
  null
  
)

export default component.exports